(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefits-in-every-bite"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const start = (media) => {
      media.loadContent?.(false);
      media.isPlaying = true;
      media.updatePlayPauseHint?.(true);
    };
    const observer =
      'IntersectionObserver' in window &&
      new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            start(entry.target);
          });
        },
        { rootMargin: '300px 0px' }
      );
    const init = () => {
      document
        .querySelectorAll('.benefits-bite deferred-media[data-lazy-autoplay]:not([data-media-loaded])')
        .forEach((media) => (observer ? observer.observe(media) : start(media)));
    };
    customElements.whenDefined('deferred-media').then(init);
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparison-vs-captioned"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-scroll-to-buy-box]');
    const buyBox = link && document.querySelector('.purchase-selector');
    if (!buyBox) return;

    event.preventDefault();
    const header = document.querySelector('#header-component, .header');
    buyBox.style.scrollMarginTop = `${(header?.offsetHeight || 0) + 16}px`;
    buyBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cost-comparison"] && !Shopify.designMode) return;
  try {
    
  // On the product page the button scrolls up to the purchase selector and pre-selects
  // the chosen pouch count with Subscribe & Save, matching the price shown in the card.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cost-compare-select]');
    if (!button) return;
    const selector = document.querySelector('purchase-selector');
    if (!selector) return;
    event.preventDefault();

    selector.querySelector(`[data-bag-option][data-quantity="${button.dataset.costCompareSelect}"]`)?.click();
    selector.querySelector('.purchase-selector__option--subscribe')?.click();

    const target = selector.closest('.purchase-selector') ?? selector;
    const header = document.querySelector('#header-component, .header');
    target.style.scrollMarginTop = `${(header?.offsetHeight || 0) + 16}px`;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dogs-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dogs-carousel')) {
    customElements.define(
      'dogs-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.dogs-story__track');
          this.dots = [...this.querySelectorAll('.dogs-story__dot')];
          if (this.dots.length < 2) return;

          this.addEventListener('click', (event) => {
            const arrow = event.target.closest('[data-dir]');
            const dot = event.target.closest('[data-index]');
            if (arrow) this.go(this.index + Number(arrow.dataset.dir));
            if (dot) this.go(Number(dot.dataset.index));
          });
          this.track.addEventListener('scroll', () => this.sync(), { passive: true });

          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (this.dataset.autoplay === 'true' && !reduce) {
            const stop = () => clearInterval(this.timer);
            const start = () => {
              stop();
              this.timer = setInterval(() => this.go(this.index + 1), Number(this.dataset.speed) || 4000);
            };
            ['mouseenter', 'focusin', 'touchstart'].forEach((type) => this.addEventListener(type, stop, { passive: true }));
            ['mouseleave', 'focusout'].forEach((type) => this.addEventListener(type, start));
            start();
          }
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        get index() {
          return Math.round(this.track.scrollLeft / this.track.clientWidth);
        }

        go(index) {
          const count = this.dots.length;
          const next = (index + count) % count;
          this.track.scrollTo({ left: next * this.track.clientWidth });
        }

        sync() {
          this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["expect-12-weeks"] && !Shopify.designMode) return;
  try {
    
  class Expect12Tabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.expect12__tab'));
      this.panels = Array.from(this.querySelectorAll('.expect12__panel'));

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', (event) => this.#onKeydown(event, index));
      });
    }

    select(index) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-expanded', String(i === index));
      });
      this.panels.forEach((panel, i) => {
        panel.hidden = i !== index;
      });
    }

    #onKeydown(event, index) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      event.preventDefault();
      const delta = event.key === 'ArrowRight' ? 1 : -1;
      const nextIndex = (index + delta + this.tabs.length) % this.tabs.length;
      this.select(nextIndex);
      this.tabs[nextIndex].focus();
    }
  }

  if (!customElements.get('expect12-tabs')) {
    customElements.define('expect12-tabs', Expect12Tabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["expert-quote"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-expert-quote-top]');
    if (!link) return;
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guarantee-band"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    // On the product page the button scrolls up to the buy box; elsewhere it follows its link to the product
    const link = event.target.closest('[data-guarantee-top]');
    const buyBox = link && document.querySelector('.purchase-selector');
    if (!buyBox) return;
    event.preventDefault();
    const header = document.querySelector('#header-component, .header');
    buyBox.style.scrollMarginTop = `${(header?.offsetHeight || 0) + 16}px`;
    buyBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gut-health-stages"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-gut-stages-next]');
    if (!link) return;
    const next = link.closest('.shopify-section')?.nextElementSibling;
    if (!next) return;
    event.preventDefault();
    const header = document.querySelector('#header-component, .header');
    next.style.scrollMarginTop = `${header?.offsetHeight || 0}px`;
    next.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  class GutStagesCounter extends HTMLElement {
    connectedCallback() {
      this.stats = Array.from(this.querySelectorAll('.gut-stages__box-stat'));
      if (this.stats.length === 0) return;

      // Only stats that contain a number (e.g. "56%", "1 in 12") can count
      // up - text-only values (e.g. "Peak diversity") are left as-is.
      // Show % raised and × at the baseline, both smaller than the number.
      this.stats.forEach((el) => {
        const text = el.textContent.trim();
        const escaped = text.replace(/&/g, '&amp;').replace(/</g, '&lt;');
        el.dataset.finalHtml = escaped.replace(/%/g, '<span class="gut-stages__unit">%</span>')
          .replace(/(\d)\s*([×xX])(?![a-zA-Z])/g, '$1<span class="gut-stages__unit gut-stages__unit--low">$2</span>');
        el.innerHTML = el.dataset.finalHtml;
        const match = text.match(/\d+(\.\d+)?/);
        if (match) el.dataset.numValue = match[0];
      });

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      // Text-only stats (e.g. "Peak diversity") can't count up, but still
      // get a fade/rise reveal so every stat moves when scrolled over.
      this.stats.forEach((el) => el.classList.add('gut-stages__box-stat--observe'));

      // Replays every time a stat scrolls back into view, rather than once.
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const el = entry.target;
            if (entry.isIntersecting) {
              el.classList.add('is-visible');
              if (el.dataset.numValue) this.#animate(el);
            } else {
              el.classList.remove('is-visible');
              if (el.dataset.numValue) this.#reset(el);
            }
          });
        },
        { threshold: 0.4 }
      );

      this.stats.forEach((el) => observer.observe(el));
    }

    #reset(el) {
      cancelAnimationFrame(el.dataset.rafId);
      const isDecimal = el.dataset.numValue.includes('.');
      el.innerHTML = el.dataset.finalHtml.replace(el.dataset.numValue, isDecimal ? '0.0' : '0');
    }

    #animate(el) {
      cancelAnimationFrame(el.dataset.rafId);

      const finalHtml = el.dataset.finalHtml;
      const target = parseFloat(el.dataset.numValue);
      const isDecimal = el.dataset.numValue.includes('.');
      const duration = 1200;
      const start = performance.now();

      const tick = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        const current = target * eased;
        const display = isDecimal ? current.toFixed(1) : String(Math.round(current));
        el.innerHTML = finalHtml.replace(el.dataset.numValue, display);

        if (progress < 1) {
          el.dataset.rafId = requestAnimationFrame(tick);
        } else {
          el.innerHTML = finalHtml;
        }
      };

      el.dataset.rafId = requestAnimationFrame(tick);
    }
  }

  if (!customElements.get('gut-stages-counter')) {
    customElements.define('gut-stages-counter', GutStagesCounter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-center"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('help-center')) {
    customElements.define(
      'help-center',
      class extends HTMLElement {
        connectedCallback() {
          this.articles = [...this.querySelectorAll('[data-help-article]')];
          this.topics = [...this.querySelectorAll('[data-help-topic]')];
          this.navLinks = [...this.querySelectorAll('[data-help-nav-link]')];
          this.empty = this.querySelector('[data-help-empty]');

          this.input = this.querySelector('[data-help-search]');
          this.results = this.querySelector('[data-help-results]');
          this.resultsText = this.querySelector('[data-help-results-text]');
          this.body = this.querySelector('.help-center__body');

          this.input?.addEventListener('input', () => {
            this.filter(this.input.value);
            clearTimeout(this.trackTimer);
            this.trackTimer = setTimeout(() => this.track(), 1500);
            clearTimeout(this.scrollTimer);
            // Desktop only: jump to results after a short pause in typing.
            if (this.input.value.trim() && window.matchMedia('(min-width: 990px)').matches) {
              this.scrollTimer = setTimeout(() => this.scrollToResults(), 700);
            }
          });

          this.input?.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter') return;
            event.preventDefault();
            clearTimeout(this.scrollTimer);
            this.filter(this.input.value);
            this.track();
            this.input.blur();
            this.scrollToResults();
          });

          this.querySelector('[data-help-clear]')?.addEventListener('click', () => {
            this.input.value = '';
            this.filter('');
            this.input.focus();
          });

          if ('IntersectionObserver' in window && this.navLinks.length) {
            this.observer = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  if (entry.isIntersecting) this.setActive(entry.target.id);
                });
              },
              { rootMargin: '-30% 0px -60% 0px' }
            );
            this.topics.forEach((topic) => this.observer.observe(topic));
          }
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          clearTimeout(this.scrollTimer);
          clearTimeout(this.trackTimer);
        }

        /** Custom storefront event for analytics (forwarded to GA4 by a Shopify custom pixel), once per settled term. */
        track() {
          clearTimeout(this.trackTimer);
          const term = this.input.value.trim().toLowerCase().slice(0, 100);
          if (term.length < 2 || term === this.lastTracked) return;
          this.lastTracked = term;
          try {
            window.Shopify?.analytics?.publish?.('help_center_search', {
              search_term: term,
              results_count: this.articles.filter((article) => !article.hidden).length,
            });
          } catch {
            // Analytics must never break search.
          }
        }

        scrollToResults() {
          if (!this.body) return;
          const header = document.querySelector('#header-component, .header');
          this.body.style.scrollMarginTop = `${(header?.offsetHeight || 0) + 24}px`;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.body.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        }

        setActive(id) {
          this.navLinks.forEach((link) => {
            const active = link.dataset.helpNavLink === id;
            link.toggleAttribute('aria-current', active);
            if (active) {
              const list = link.closest('ul');
              if (list && list.scrollWidth > list.clientWidth) {
                list.scrollTo({ left: link.offsetLeft - 20, behavior: 'smooth' });
              }
            }
          });
        }

        filter(value) {
          const query = value.trim().toLowerCase();
          let matches = 0;

          this.articles.forEach((article) => {
            const hit = !query || article.textContent.toLowerCase().includes(query);
            article.hidden = !hit;
            article.open = Boolean(query) && hit;
            if (hit) matches += 1;
          });

          this.topics.forEach((topic) => {
            const visible = Boolean(topic.querySelector('[data-help-article]:not([hidden])'));
            topic.hidden = !visible;
            const link = this.querySelector(`[data-help-nav-link="${topic.id}"]`);
            if (link) link.parentElement.hidden = !visible;
          });

          if (this.empty) this.empty.hidden = matches > 0;
          if (this.results) {
            this.results.hidden = !query;
            const label = matches === 1 ? 'answer' : 'answers';
            this.resultsText.textContent = `${matches} ${label} for “${value.trim()}”`;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredient-gallery"] && !Shopify.designMode) return;
  try {
    
  class IngredientRevealGroup extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.ingredient-card'));

      this.cards.forEach((card) => {
        const toggle = card.querySelector('.ingredient-card__toggle');
        if (toggle) toggle.addEventListener('click', () => this.toggle(card));
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.closeAll();
      });

      const section = this.closest('.ingredient-gallery-section');
      this.prevButton = section && section.querySelector('.ingredient-gallery__scroll-hint--prev');
      this.nextButton = section && section.querySelector('.ingredient-gallery__scroll-hint--next');

      if (this.prevButton) this.prevButton.addEventListener('click', () => this.scrollByCard(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.scrollByCard(1));

      if (this.prevButton || this.nextButton) {
        this.addEventListener('scroll', () => this.updateScrollButtons(), { passive: true });
        window.addEventListener('resize', () => this.updateScrollButtons());
        this.updateScrollButtons();
      }

      if (this.dataset.autoplay === 'true') this.setupAutoplay();
    }

    scrollByCard(direction) {
      const card = this.querySelector('.ingredient-card, .group-block');
      const amount = card ? card.getBoundingClientRect().width + 16 : this.clientWidth * 0.8;
      this.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    setupAutoplay() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const speed = Math.max(parseFloat(this.dataset.autoplaySpeed) || 4, 0.5) * 1000;
      let timer = null;
      let stoppedByUser = false;

      const tick = () => {
        const maxScroll = this.scrollWidth - this.clientWidth;
        if (this.scrollLeft >= maxScroll - 4) {
          this.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          this.scrollByCard(1);
        }
      };

      const start = () => {
        if (timer || stoppedByUser) return;
        timer = setInterval(tick, speed);
      };

      const stop = () => {
        clearInterval(timer);
        timer = null;
      };

      const stopForGood = () => {
        stoppedByUser = true;
        stop();
      };

      this.addEventListener('mouseenter', stop);
      this.addEventListener('mouseleave', start);
      this.addEventListener('pointerdown', stopForGood, { passive: true });
      if (this.prevButton) this.prevButton.addEventListener('click', stopForGood);
      if (this.nextButton) this.nextButton.addEventListener('click', stopForGood);

      new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => (entry.isIntersecting ? start() : stop()));
        },
        { threshold: 0.4 }
      ).observe(this);
    }

    updateScrollButtons() {
      const maxScroll = this.scrollWidth - this.clientWidth;
      if (this.prevButton) this.prevButton.disabled = this.scrollLeft <= 4;
      if (this.nextButton) this.nextButton.disabled = this.scrollLeft >= maxScroll - 4;
    }

    toggle(card) {
      const isOpen = card.classList.contains('is-revealed');
      this.closeAll();
      if (!isOpen) this.open(card);
    }

    open(card) {
      card.classList.add('is-revealed');
      const toggle = card.querySelector('.ingredient-card__toggle');
      const reveal = card.querySelector('.ingredient-card__reveal');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      if (reveal) reveal.setAttribute('aria-hidden', 'false');
    }

    closeAll() {
      this.cards.forEach((card) => {
        card.classList.remove('is-revealed');
        const toggle = card.querySelector('.ingredient-card__toggle');
        const reveal = card.querySelector('.ingredient-card__reveal');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        if (reveal) reveal.setAttribute('aria-hidden', 'true');
      });
    }
  }

  if (!customElements.get('ingredient-reveal-group')) {
    customElements.define('ingredient-reveal-group', IngredientRevealGroup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredient-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ingredient-story')) {
    class IngredientStory extends HTMLElement {
      connectedCallback() {
        this.steps = [...this.querySelectorAll('.ing-story__step')];
        if (!this.steps.length) return;
        const stage = this.querySelector('.ing-story__stage');
        const dotList = this.querySelector('.ing-story__dots');
        this.images = [];
        this.dots = [];
        this.steps.forEach((step, index) => {
          const media = step.querySelector('.ing-story__image');
          if (media && stage) {
            media.hidden = false;
            media.dataset.index = index;
            stage.prepend(media);
            this.images.push(media);
          }
          if (dotList) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'ing-story__dot';
            dot.dataset.go = index;
            dot.style.setProperty('--ing-story-step-color', step.dataset.color);
            const label = document.createElement('span');
            label.textContent = step.dataset.word;
            dot.append(label);
            dotList.append(dot);
            this.dots.push(dot);
          }
        });
        const dishes = this.querySelector('.ing-story__cta-dishes');
        if (dishes) {
          this.steps.forEach((step) => {
            if (!step.dataset.thumb) return;
            const dish = document.createElement('span');
            const img = document.createElement('img');
            img.src = step.dataset.thumb;
            img.alt = '';
            img.loading = 'lazy';
            dish.append(img);
            dishes.append(dish);
          });
        }
        this.fill = this.querySelector('.ing-story__line-fill');
        this.barImg = this.querySelector('.ing-story__bar-img');
        this.barWord = this.querySelector('.ing-story__bar-word');
        this.barName = this.querySelector('.ing-story__bar-name');
        this.barProgress = this.querySelector('.ing-story__bar-progress i');
        this.current = -1;

        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.update();
          });
        };
        document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
        window.addEventListener('resize', this.onScroll);

        this.dots.forEach((dot) =>
          dot.addEventListener('click', () => {
            const step = this.steps[Number(dot.dataset.go)];
            step?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          })
        );

        this.setActive(0);
        this.update();
      }

      disconnectedCallback() {
        document.removeEventListener('scroll', this.onScroll, { capture: true });
        window.removeEventListener('resize', this.onScroll);
      }

      update() {
        const target = window.innerHeight * 0.45;
        let best = 0;
        let distance = Infinity;
        this.steps.forEach((step, index) => {
          const d = Math.abs(step.getBoundingClientRect().top + 36 - target);
          if (d < distance) {
            distance = d;
            best = index;
          }
        });
        this.setActive(best);
      }

      setActive(index) {
        if (index === this.current) return;
        this.current = index;
        const step = this.steps[index];

        this.steps.forEach((el, i) => {
          el.classList.toggle('is-active', i === index);
          el.classList.toggle('is-done', i < index);
        });
        this.dots.forEach((el, i) => {
          el.classList.toggle('is-active', i === index);
          el.classList.toggle('is-done', i < index);
          el.setAttribute('aria-current', i === index ? 'step' : 'false');
        });
        this.images.forEach((img) => {
          const on = Number(img.dataset.index) === index;
          img.classList.toggle('is-active', on);
          if (on) img.querySelector('img')?.setAttribute('loading', 'eager');
        });

        const word = step.dataset.word;
        const name = step.dataset.heading;
        this.style.setProperty('--ing-story-current', step.dataset.color);
        if (this.barWord) this.barWord.textContent = word;
        if (this.barName) this.barName.textContent = name;
        if (this.barImg && step.dataset.thumb) this.barImg.src = step.dataset.thumb;
        if (this.barProgress) this.barProgress.style.width = `${((index + 1) / this.steps.length) * 100}%`;
        if (this.fill) this.fill.style.height = `${step.offsetTop}px`;
      }
    }
    customElements.define('ingredient-story', IngredientStory);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredient-timeline"] && !Shopify.designMode) return;
  try {
    
  class IngredientTimeline extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ing-timeline__track');
      this.svg = this.querySelector('.ing-timeline__svg');
      this.basePath = this.querySelector('.ing-timeline__path-base');
      this.accentPath = this.querySelector('.ing-timeline__path-accent');
      this.dot = this.querySelector('.ing-timeline__dot');
      this.nodes = Array.from(this.querySelectorAll('.ing-timeline__node'));
      this.steps = Array.from(this.querySelectorAll('.ing-timeline__step'));

      if (!this.track || this.nodes.length === 0) return;

      this.isDesktop = window.matchMedia('(min-width: 750px)').matches;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.#buildPath();
      this.#setupScroll();

      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          this.isDesktop = window.matchMedia('(min-width: 750px)').matches;
          this.#buildPath();
        }, 150);
      });

      // Icons/webfonts can shift node positions after the first paint;
      // re-measure once everything has finished loading.
      window.addEventListener('load', () => this.#buildPath());
    }

    #updateActiveStepByViewport() {
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const viewportCenter = viewportHeight * 0.5;
      let closestIndex = 0;
      let closestDistance = Infinity;

      this.steps.forEach((step, index) => {
        const rect = step.getBoundingClientRect();
        const center = rect.top + rect.height / 2;
        const distance = Math.abs(center - viewportCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      this.steps.forEach((step, index) => step.classList.toggle('is-active', index === closestIndex));
    }

    // A node is "reached" exactly when it crosses the vertical center of the
    // viewport - matching the reference site's behaviour. Interpolating the
    // drawn line length between each pair of nodes (rather than using a
    // separate scroll-fraction formula) guarantees the line, the dot and the
    // highlighted circle always agree on exactly where "reached" is.
    #getProgressFromNodePositions(viewportCenter, startY) {
      const nodeYs = this.nodes.map((node) => {
        const rect = node.getBoundingClientRect();
        return rect.top + rect.height / 2;
      });

      // Prepend the lead-in's start point so the cursor animates along that
      // horizontal run-out too, instead of popping straight to node 0.
      const allYs = [startY, ...nodeYs];
      const allLengths = [0, ...this.nodeLengths];

      if (viewportCenter <= allYs[0]) {
        return { activeIndex: -1, drawnLength: 0, engaged: false };
      }
      if (viewportCenter >= allYs[allYs.length - 1]) {
        return {
          activeIndex: nodeYs.length - 1,
          drawnLength: allLengths[allLengths.length - 1],
          engaged: true,
        };
      }

      for (let i = 0; i < allYs.length - 1; i++) {
        if (viewportCenter >= allYs[i] && viewportCenter <= allYs[i + 1]) {
          const span = allYs[i + 1] - allYs[i] || 1;
          const fraction = (viewportCenter - allYs[i]) / span;
          const drawnLength = allLengths[i] + fraction * (allLengths[i + 1] - allLengths[i]);
          // Only the node the cursor has actually arrived at counts as
          // "reached" - while still travelling toward the next one (i), the
          // previous node (i - 1) stays highlighted instead of lighting up
          // early. i=0's segment is the lead-in, so its "from" is -1 (none).
          const activeIndex = i - 1;
          return { activeIndex, drawnLength, engaged: true };
        }
      }

      return { activeIndex: -1, drawnLength: 0, engaged: false };
    }

    #buildPath() {
      if (!this.svg || !this.basePath) return;

      if (!this.isDesktop) {
        this.svg.style.display = 'none';
        return;
      }
      this.svg.style.display = 'block';

      const trackRect = this.track.getBoundingClientRect();
      const width = trackRect.width;
      const height = this.track.offsetHeight;

      this.svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
      this.svg.setAttribute('width', width);
      this.svg.setAttribute('height', height);

      const points = this.nodes.map((node) => {
        const rect = node.getBoundingClientRect();
        return {
          x: rect.left + rect.width / 2 - trackRect.left,
          y: rect.top + rect.height / 2 - trackRect.top,
        };
      });

      if (points.length === 0) return;

      // Lead-in: a horizontal line runs out from the section's left edge,
      // right under the intro paragraph, and bends into the first node.
      const leadY = 8;
      this.leadY = leadY;
      const bendX = Math.max(points[0].x - 70, 0);
      const dropMidY = leadY + (points[0].y - leadY) * 0.5;
      let d = `M 0 ${leadY} H ${bendX} C ${bendX + 40} ${leadY}, ${points[0].x} ${dropMidY}, ${points[0].x} ${points[0].y}`;

      // Measure the path's length up to each node as it's built, so scroll
      // progress can later be compared against exactly where each node sits
      // along the curve (rather than guessed from viewport position).
      this.basePath.setAttribute('d', d);
      const nodeLengths = [this.basePath.getTotalLength()];

      for (let i = 0; i < points.length - 1; i++) {
        const p0 = points[i];
        const p1 = points[i + 1];
        const midY = (p0.y + p1.y) / 2;
        d += ` C ${p0.x} ${midY}, ${p1.x} ${midY}, ${p1.x} ${p1.y}`;
        this.basePath.setAttribute('d', d);
        nodeLengths.push(this.basePath.getTotalLength());
      }

      const last = points[points.length - 1];
      d += ` L ${last.x} ${Math.min(last.y + 40, height)}`;

      this.basePath.setAttribute('d', d);
      this.accentPath.setAttribute('d', d);
      this.pathLength = this.basePath.getTotalLength();
      this.nodeLengths = nodeLengths;
      this.accentPath.style.strokeDasharray = String(this.pathLength);
      this.accentPath.style.strokeDashoffset = String(this.pathLength);
    }

    // This theme scrolls `.page-wrapper` (not `window`) at desktop widths
    // (see html:has(.page-wrapper) { overflow: hidden } in base.css), so the
    // scroll listener has to be bound to whichever ancestor actually scrolls.
    #findScrollTarget() {
      let el = this.parentElement;
      while (el) {
        const style = getComputedStyle(el);
        if ((style.overflowY === 'auto' || style.overflowY === 'scroll') && el.scrollHeight > el.clientHeight + 1) {
          return el;
        }
        el = el.parentElement;
      }
      return window;
    }

    #setupScroll() {
      let ticking = false;

      const update = () => {
        ticking = false;

        const rect = this.track.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

        if (this.reducedMotion || !this.isDesktop || !this.pathLength || !this.dot) {
          if (rect.bottom > 0 && rect.top < viewportHeight) {
            this.#updateActiveStepByViewport();
          }
          if (this.dot) this.dot.style.opacity = '0';
          return;
        }

        const viewportCenter = viewportHeight * 0.5;
        const startY = rect.top + this.leadY;
        const { activeIndex, drawnLength, engaged } = this.#getProgressFromNodePositions(viewportCenter, startY);

        // Drive the drawn line, the step highlight and the scoop cursor off
        // the exact same node-position data so they can never drift apart.
        this.accentPath.style.strokeDashoffset = String(this.pathLength - drawnLength);
        this.steps.forEach((step, index) => step.classList.toggle('is-active', index === activeIndex));

        if (!engaged) {
          this.dot.style.opacity = '0';
        } else {
          this.dot.style.opacity = '1';
          const point = this.accentPath.getPointAtLength(drawnLength);
          // Keep the scoop upright rather than rotating to face the curve -
          // rotating made it flip awkwardly through the S-bends.
          this.dot.setAttribute('transform', `translate(${point.x}, ${point.y})`);
        }
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      };

      let currentTarget = null;
      const bind = () => {
        const nextTarget = this.#findScrollTarget();
        if (nextTarget === currentTarget) return;
        if (currentTarget) currentTarget.removeEventListener('scroll', onScroll);
        currentTarget = nextTarget;
        currentTarget.addEventListener('scroll', onScroll, { passive: true });
      };

      bind();
      update();

      // The scroll container itself can change at the 990px breakpoint
      // (see #findScrollTarget), so re-detect it whenever the layout resizes.
      window.addEventListener('resize', () => {
        bind();
        update();
      });
    }
  }

  if (!customElements.get('ingredient-timeline')) {
    customElements.define('ingredient-timeline', IngredientTimeline);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["journey-ingredients"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-journey-scroll]');
    if (!arrow) return;
    const section = arrow.closest('.journey-ingredients');
    const row = section?.querySelector('[data-journey-row]');
    const card = row?.querySelector('.journey-ingredient-item');
    if (!row || !card) return;
    const step = card.getBoundingClientRect().width + 16;
    row.scrollBy({ left: step * Number(arrow.dataset.journeyScroll), behavior: 'smooth' });
  });

  const updateJourneyArrows = (row) => {
    const section = row.closest('.journey-ingredients');
    const [prev, next] = section.querySelectorAll('[data-journey-scroll]');
    if (!prev || !next) return;
    prev.disabled = row.scrollLeft <= 2;
    next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 2;
  };

  const initJourneyArrows = () => {
    document.querySelectorAll('[data-journey-row]').forEach((row) => {
      if (row.dataset.arrowsReady) return;
      row.dataset.arrowsReady = 'true';
      row.addEventListener('scroll', () => updateJourneyArrows(row), { passive: true });
      updateJourneyArrows(row);
    });
  };
  initJourneyArrows();
  document.addEventListener('shopify:section:load', initJourneyArrows);

  const touchQuery = window.matchMedia('(hover: none), (pointer: coarse)');

  class IngredientRevealGroup extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.ingredient-card'));

      // Touch devices: tap anywhere on the card, same as the "+" button. Elsewhere only "+" toggles.
      this.cards.forEach((card) => {
        card.addEventListener('click', (event) => {
          if (event.target.closest('a')) return;
          if (!event.target.closest('.ingredient-card__toggle') && !touchQuery.matches) return;
          this.toggle(card);
        });
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.closeAll();
      });
    }

    toggle(card) {
      const isOpen = card.classList.contains('is-revealed');
      this.closeAll();
      if (!isOpen) this.open(card);
    }

    open(card) {
      card.classList.add('is-revealed');
      const toggle = card.querySelector('.ingredient-card__toggle');
      const reveal = card.querySelector('.ingredient-card__reveal');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      if (reveal) reveal.setAttribute('aria-hidden', 'false');
    }

    closeAll() {
      this.cards.forEach((card) => {
        card.classList.remove('is-revealed');
        const toggle = card.querySelector('.ingredient-card__toggle');
        const reveal = card.querySelector('.ingredient-card__reveal');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        if (reveal) reveal.setAttribute('aria-hidden', 'true');
      });
    }
  }

  if (!customElements.get('ingredient-reveal-group')) {
    customElements.define('ingredient-reveal-group', IngredientRevealGroup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-highlights"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-product-highlights-scroll]');
    if (!link) return;
    const target = document.querySelector('purchase-selector, .product-information, [id*="__main"]');
    if (!target) return;
    event.preventDefault();
    const header = document.querySelector('#header-component, .header');
    target.style.scrollMarginTop = `${(header?.offsetHeight || 0) + 16}px`;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["research-cards"] && !Shopify.designMode) return;
  try {
    
  class ResearchFilter extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.research-card'));
      this.filtersEl = this.querySelector('.research-cards__filters');

      // Section-level Liquid can't see into each block's own settings in
      // this theme's block system, so the category tabs are built here from
      // the data-category attribute each card already renders correctly.
      this.#buildCategoryTabs();

      this.tabs = Array.from(this.querySelectorAll('.research-cards__filter-tab'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.filter(tab));
      });
    }

    #buildCategoryTabs() {
      if (!this.filtersEl) return;

      const seen = new Set();
      const categories = [];
      this.cards.forEach((card) => {
        const category = card.dataset.category;
        if (category && !seen.has(category)) {
          seen.add(category);
          categories.push(category);
        }
      });

      categories.forEach((category) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'research-cards__filter-tab';
        button.dataset.filter = category;
        button.textContent = category;
        this.filtersEl.appendChild(button);
      });
    }

    filter(activeTab) {
      const category = activeTab.dataset.filter;
      this.tabs.forEach((tab) => tab.classList.toggle('is-active', tab === activeTab));
      this.cards.forEach((card) => {
        card.hidden = category !== 'all' && card.dataset.category !== category;
      });
    }
  }

  if (!customElements.get('research-filter')) {
    customElements.define('research-filter', ResearchFilter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["research-studies"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('research-studies')) {
    class ResearchStudies extends HTMLElement {
      connectedCallback() {
        this.cards = [...this.querySelectorAll('.research-study')];
        const tabList = this.querySelector('.research-studies__tabs');
        const allTab = tabList.querySelector('[data-tab="all"]');
        const seen = new Set();
        this.cards.forEach((card) => {
          const key = card.dataset.benefit;
          if (!key || seen.has(key)) return;
          seen.add(key);
          const tab = allTab.cloneNode(false);
          tab.dataset.tab = key;
          tab.textContent = card.dataset.benefitLabel;
          tabList.append(tab);
        });
        this.tabs = [...tabList.querySelectorAll('.research-studies__tab')];
        this.rail = this.querySelector('.research-studies__rail');
        this.dots = this.querySelector('.research-studies__dots');
        this.prev = this.querySelector('.research-studies__arrow--prev');
        this.next = this.querySelector('.research-studies__arrow--next');

        this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(tab.dataset.tab)));
        this.prev?.addEventListener('click', () => this.step(-1));
        this.next?.addEventListener('click', () => this.step(1));
        this.rail.addEventListener('scroll', () => this.update(), { passive: true });
        window.addEventListener('resize', () => this.update(), { passive: true });

        const wanted = this.dataset.default;
        this.select(this.tabs.some((t) => t.dataset.tab === wanted) ? wanted : 'all');
      }

      visible() {
        return this.cards.filter((card) => !card.hidden);
      }

      select(key) {
        this.tabs.forEach((tab) => tab.setAttribute('aria-selected', String(tab.dataset.tab === key)));
        this.cards.forEach((card) => {
          card.hidden = !(key === 'all' || card.dataset.benefit === key);
        });
        this.rail.scrollLeft = 0;
        const count = this.visible().length;
        this.dots.innerHTML = count > 8 ? '' : this.visible().map(() => '<i></i>').join('');
        this.update();
      }

      step(direction) {
        const card = this.visible()[0];
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 12;
        this.rail.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
      }

      update() {
        const rail = this.rail;
        const visible = this.visible();
        let index = 0;
        let best = Infinity;
        visible.forEach((card, i) => {
          const distance = Math.abs(card.offsetLeft - rail.offsetLeft - rail.scrollLeft);
          if (distance < best) {
            best = distance;
            index = i;
          }
        });
        [...this.dots.children].forEach((dot, i) => dot.classList.toggle('is-active', i === index));
        const max = rail.scrollWidth - rail.clientWidth;
        if (this.prev) this.prev.disabled = rail.scrollLeft <= 2;
        if (this.next) this.next.disabled = rail.scrollLeft >= max - 2;
        this.classList.toggle('research-studies--fits', max <= 2);
      }
    }
    customElements.define('research-studies', ResearchStudies);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-scroll"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('story-scroll')) {
    customElements.define(
      'story-scroll',
      class extends HTMLElement {
        connectedCallback() {
          this.steps = [...this.querySelectorAll('[data-story-step]')];
          this.images = [...this.querySelectorAll('[data-story-image]')];
          if (!('IntersectionObserver' in window) || !this.steps.length) return;

          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) this.activate(entry.target.dataset.storyStep);
              });
            },
            { rootMargin: '-45% 0px -45% 0px' }
          );
          this.steps.forEach((step) => this.observer.observe(step));
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        activate(index) {
          this.steps.forEach((step) => step.classList.toggle('is-active', step.dataset.storyStep === index));
          this.images.forEach((image) => image.classList.toggle('is-active', image.dataset.storyImage === index));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-popup"]) return;
  try {
    
  if (!customElements.get('welcome-popup')) {
    const STORE_KEY = 'tael-welcome-popup';

    class WelcomePopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.email = '';
        this.addEventListener('click', (e) => this.onClick(e));
        this.querySelector('[data-step="email"]').addEventListener('submit', (e) => this.submitEmail(e));
        this.querySelector('[data-step="details"]').addEventListener('submit', (e) => this.submitDetails(e));
        this.dialog.addEventListener('cancel', () => this.dismiss());
        this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.dismiss(); });

        if (this.hasAttribute('data-design-mode')) {
          document.addEventListener('shopify:section:select', (e) => { if (e.detail.sectionId === this.dataset.sectionId) this.open(); });
          document.addEventListener('shopify:section:deselect', (e) => { if (e.detail.sectionId === this.dataset.sectionId) this.dialog.close(); });
          return;
        }
        if (!this.shouldShow()) return;
        this.timer = setTimeout(() => this.open(), (Number(this.dataset.delay) || 15) * 1000);
      }

      disconnectedCallback() { clearTimeout(this.timer); }

      state() {
        try { return JSON.parse(localStorage.getItem(STORE_KEY)) || {}; } catch (e) { return {}; }
      }

      save(data) {
        try { localStorage.setItem(STORE_KEY, JSON.stringify({ ...this.state(), ...data })); } catch (e) {}
      }

      shouldShow() {
        const s = this.state();
        if (s.subscribed) return false;
        return !(s.hideUntil && Date.now() < s.hideUntil);
      }

      open() {
        if (this.dialog.open) return;
        this.dialog.showModal();
        if (!this.hasAttribute('data-design-mode')) this.track('Viewed welcome pop-up');
      }

      dismiss() {
        if (!this.hasAttribute('data-design-mode') && !this.state().subscribed) {
          this.save({ hideUntil: Date.now() + (Number(this.dataset.hideDays) || 14) * 864e5 });
        }
        this.dialog.close();
      }

      onClick(e) {
        if (e.target.closest('[data-close]')) this.dismiss();
        if (e.target.closest('[data-skip]')) this.show('success');
      }

      show(step) {
        this.querySelectorAll('[data-step]').forEach((el) => { el.hidden = el.dataset.step !== step; });
        const focusable = this.querySelector(`[data-step="${step}"] input, [data-step="${step}"] a`);
        if (focusable) focusable.focus();
      }

      track(metric) {
        window.klaviyo = window.klaviyo || [];
        window.klaviyo.push(['track', metric, { source: this.dataset.source }]);
      }

      async submitEmail(e) {
        e.preventDefault();
        const form = e.currentTarget;
        const input = form.elements.email;
        const error = form.querySelector('.welcome-popup__error');
        const button = form.querySelector('button[type="submit"]');
        const email = input.value.trim();

        if (!window.taelKlaviyo || !window.taelKlaviyo.isValidEmail(email)) {
          error.textContent = 'Please enter a valid email address.';
          error.hidden = false;
          input.focus();
          return;
        }

        error.hidden = true;
        button.disabled = true;
        try {
          await window.taelKlaviyo.subscribe({
            email,
            companyId: this.dataset.companyId,
            listId: this.dataset.listId,
            source: this.dataset.source,
          });
          this.email = email;
          this.track('Signed up via welcome pop-up');
          this.show('details');
        } catch (err) {
          error.textContent = 'Something went wrong. Please try again.';
          error.hidden = false;
        } finally {
          button.disabled = false;
        }
      }

      async submitDetails(e) {
        e.preventDefault();
        const form = e.currentTarget;
        const firstName = form.elements.first_name.value.trim();
        const dogName = form.elements.dog_name.value.trim();
        if (this.email && (firstName || dogName)) {
          window.taelKlaviyo
            .updateProfile({
              email: this.email,
              companyId: this.dataset.companyId,
              firstName,
              properties: dogName ? { 'Dog name': dogName } : {},
            })
            .catch(() => {});
        }
        this.show('success');
      }
    }

    customElements.define('welcome-popup', WelcomePopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-subscribe"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-why-subscribe-scroll]');
    if (!link) return;
    const target = document.querySelector('purchase-selector, .product-information');
    if (!target) return;
    event.preventDefault();
    target.querySelector('.purchase-selector__option--subscribe')?.click();
    const header = document.querySelector('#header-component, .header');
    target.style.scrollMarginTop = `${(header?.offsetHeight || 0) + 16}px`;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();
})();
